"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuspenseResourceStorage = void 0;
const suspense_resource_1 = require("./suspense-resource");
class SuspenseResourceStorage {
    constructor() {
        this.map = new Map();
        this.getOrAdd = (name, path, factory) => {
            var _a;
            return (_a = this.map.get(this.getKey(name, path))) !== null && _a !== void 0 ? _a : this.create(name, path, factory);
        };
        this.create = (name, path, factory) => {
            const resource = new suspense_resource_1.SuspenseResource(factory());
            this.map.set(this.getKey(name, path), resource);
            return resource;
        };
        this.delete = (name, path) => {
            this.map.delete(this.getKey(name, path));
        };
    }
    getKey(name, path) {
        return `${name}_${path}`;
    }
}
exports.SuspenseResourceStorage = SuspenseResourceStorage;
//# sourceMappingURL=suspense-resource-storage.js.map